exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labeled-input[data-v-3a82263c] label,.labeled-input[data-v-3a82263c] legend{font-weight:700}.labeled-input .bv-no-focus-ring[data-v-3a82263c],.labeled-input[data-v-3a82263c] .bv-no-focus-ring,.labeled-input[data-v-3a82263c] [role=group],.labeled-input select[data-v-3a82263c]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a82263c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/LabeledInput.vue
// module id = 931
// module chunks = 0